import { combineReducers } from 'redux';

import user from 'rebook/apps/users/reducers/user';
import payments from 'rebook/apps/payments/reducers/payments';
import authForm from 'rebook/apps/users/reducers/authForm';
import notifications from 'rebook/apps/users/reducers/notifications';
import userBookshelfDetail from 'rebook/apps/users/reducers/userBookshelfDetail';
import modalDialogs from 'rebook/apps/base/reducers/modalDialogs';
import error404 from 'rebook/apps/base/reducers/error404';
import promoCampaign from 'rebook/apps/advert/reducers/promoCampaign';
import ssr from 'rebook/apps/base/reducers/ssr';
import seo from 'rebook/apps/base/reducers/seo';
import player from 'rebook/apps/base/reducers/player';
import dashboardBlockList from 'rebook/apps/dashboard/reducers/dashboardBlockList';
import bookAuthorList from 'rebook/apps/books/reducers/bookAuthorList';
import bookDetail from 'rebook/apps/books/reducers/bookDetail';
import bookFragment from 'rebook/apps/books/reducers/bookFragment';
import bookReviewList from 'rebook/apps/books/reducers/bookReviewList';
import bookReview from 'rebook/apps/books/reducers/bookReview';
import bookCitation from 'rebook/apps/books/reducers/bookCitation';
import bookCitationList from 'rebook/apps/books/reducers/bookCitationList';
import booksPerSubscriptionCounter from 'rebook/apps/books/reducers/booksPerSubscriptionCounter';
import booksetDetail from 'rebook/apps/catalog/reducers/booksetDetail';
import booksetList from 'rebook/apps/catalog/reducers/booksetList';
import bookshelfDetail from 'rebook/apps/catalog/reducers/bookshelfDetail';
import seriesDetail from 'rebook/apps/catalog/reducers/seriesDetail';
import authorReviewList from 'rebook/apps/catalog/reducers/authorReviewList';
import authorCitationList from 'rebook/apps/catalog/reducers/authorCitationList';
import staticPage from 'rebook/apps/pages/reducers/staticPage';
import searchQuery from 'rebook/apps/search/reducers/searchQuery';
import searchBooks from 'rebook/apps/search/reducers/searchBooks';
import searchAudioBooks from 'rebook/apps/search/reducers/searchAudioBooks';
import searchAuthors from 'rebook/apps/search/reducers/searchAuthors';
import searchGenresThemes from 'rebook/apps/search/reducers/searchGenresThemes';
import searchSeries from 'rebook/apps/search/reducers/searchSeries';
import searchBooksets from 'rebook/apps/search/reducers/searchBooksets';
import searchRightholders from 'rebook/apps/search/reducers/searchRightholders';
import authorDetail from 'rebook/apps/catalog/reducers/authorDetail';
import authorBookList from 'rebook/apps/catalog/reducers/authorBookList';
import authorList from 'rebook/apps/catalog/reducers/authorList';
import nicheDetail from 'rebook/apps/catalog/reducers/nicheDetail';
import genreDetail from 'rebook/apps/catalog/reducers/genreDetail';
import tagDetail from 'rebook/apps/catalog/reducers/tagDetail';
import catalogIndex from 'rebook/apps/catalog/reducers/catalogIndex';
import catalogFreeIndex from 'rebook/apps/catalog/reducers/catalogFreeIndex';
import catalogBookList from 'rebook/apps/catalog/reducers/catalogBookList';
import tagList from 'rebook/apps/catalog/reducers/tagList';
import userWallets from 'rebook/apps/users/reducers/userWallets';
import landing from 'rebook/apps/landing/reducers/landing';
import faqIndex from 'rebook/apps/faq/reducers/faqIndex';
import faqQuestion from 'rebook/apps/faq/reducers/faqQuestion';
import nicheBookList from 'rebook/apps/catalog/reducers/nicheBookList';
import similarBooks from 'rebook/apps/books/reducers/similarBooks';
import actorAudiobookList from 'rebook/apps/catalog/reducers/actorAudiobookList';
import rightholderBookList from 'rebook/apps/catalog/reducers/rightholderBookList';


export default combineReducers({
  user,
  payments,
  userWallets,
  searchQuery,
  authForm,
  notifications,
  modalDialogs,
  error404,
  ssr,
  seo,
  player,
  promoCampaign,

  authorReviewList,
  authorCitationList,
  booksPerSubscriptionCounter,
  dashboardBlockList,
  bookAuthorList,
  bookDetail,
  bookFragment,
  bookReview,
  bookReviewList,
  bookCitation,
  bookCitationList,
  booksetDetail,
  bookshelfDetail,
  userBookshelfDetail,
  seriesDetail,
  staticPage,
  authorDetail,
  authorBookList,
  authorList,
  nicheDetail,
  genreDetail,
  tagDetail,
  catalogIndex,
  catalogFreeIndex,
  catalogBookList,
  landing,
  tagList,
  faqIndex,
  faqQuestion,
  nicheBookList,
  booksetList,
  searchBooks,
  searchAudioBooks,
  searchGenresThemes,
  searchAuthors,
  searchSeries,
  searchBooksets,
  searchRightholders,
  similarBooks,
  actorAudiobookList,
  rightholderBookList,
});
